import React, { useEffect } from 'react'
import { useGeneralParams } from '../../../../hooks/useDataPaginate'
import { MinimalActionButton } from '../../../../components/form/minimalActionButton'
import { setReloadMainTable } from '../../../../store/slices/auth/authSlice'
import { TabBoard } from '../../../../components/tab/TabBoard'
import Bars from './VentaPorVendedorProductoBarsCharts'
import Pies from './VentasCreditoPiesCharts'
import { DefaultParamsForRecall, formatFilters } from '../../../../utils/defaulStates'
import { DefaultMultiSelectVendedores } from '../../../../components/defaults'

export const VentasPorVendedor = ({ urlApi, title, subtitle }) => {
    const {
        dispatch,
        data, setData,
        paginate, setPaginate,
        selectedDay, setSelectedDay,
        selecteds, setSelecteds,
        selectAllChecked, setSelectAllChecked,
        isChecked, setIsChecked,
        stateData, setStateData,
        // updateModal, setUpdateModal,
        // deleteModal, setDeleteModal,
        // currentData, setCurrentData,
        // imports
        requestAuthPaginate,
        TableContainer,
        Paginator,
        // formatFilters,
        // FilterSelect,
        RangeDate,
        // Actions,
        TableSection,
        ActionSection,
        Section,

    } = useGeneralParams({ aditionals: { rolnames: ['carro-distribuidor', 'punto-de-venta'] } })

    const getDataPaginate = async () => {
        await requestAuthPaginate({
            method: 'get',
            url: urlApi,
            data: null,
            queries: paginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: { filterBy: 'nombre' }
        })
    }
    useEffect(() => {
        getDataPaginate();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), paginate.rolnames]);

    // useEffect(() => {
    //     console.log(selecteds)
    // }, [selecteds]);

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate)]);

    const recall = () => {
        getDataPaginate()
        setSelecteds([])
        setSelectAllChecked(false)
        setIsChecked(false)
        dispatch(setReloadMainTable())
    }
    return (
        <TabBoard
            title={title}
            subtitle={subtitle}
        >
            <Section>
                <ActionSection>
                    <div className='flex gap-2 flex-wrap'>
                        <RangeDate
                            selectedDay={selectedDay}
                            setSelectedDay={setSelectedDay}
                            paginate={paginate}
                            setPaginate={setPaginate}
                        />
                        <DefaultMultiSelectVendedores
                            paginate={paginate}
                            setPaginate={setPaginate}
                            formatFilter={formatFilters}
                        />
                        <MinimalActionButton
                            icon='repeat'
                            label=''
                            action={recall}
                        />
                    </div>
                </ActionSection>
                <TableSection
                    stateData={stateData}
                    paginator={Paginator}
                    data={data}
                >
                    <TableContainer
                        headers={[
                            {
                                label: 'Responsable',
                                columns: ['nombres:apellido_paterno:apellido_materno', 'roles']
                            },
                        ]}
                        data={data.data}
                        aditionalCols={data.aditionalCols}
                        aditionalColsRef='cantidades'
                        aditionalColsAmount={true}
                        checkList={false}
                        selecteds={selecteds}
                        setSelecteds={setSelecteds}
                        selectAllChecked={selectAllChecked}
                        setSelectAllChecked={setSelectAllChecked}
                        isChecked={isChecked}
                        setIsChecked={setIsChecked}
                        stateData={stateData}
                    />
                </TableSection>
            </Section>
            <Bars
                data={data.data}
                aditionalCols={data.aditionalCols}
                title='TOTAL VENTAS'
                hoverTitle='Ventas'
            />
            <Pies
                data={data.data}
                aditionalCols={data.aditionalCols}
                title='VENTAS AL CONTADO'
                hoverTitle='Ventas'
                position={0}
            />
            <Pies
                data={data.data}
                aditionalCols={data.aditionalCols}
                title='VENTAS A CREDITO'
                hoverTitle='Ventas'
                position={1}
            />
        </TabBoard>
    )
}